import React from 'react';
import { graphql } from 'gatsby';

import Website from 'components/ui-setup';
import Layout from 'components/layout';
import PrivacySurveillance from 'components/privacy-surveillance';

type Props = {
  data: Object,
};

const PrivacySurveillancePage = ({ data }: Props) => {
  const {
    privacySurveillanceJson,
    logoJson,
    socialMediaJson,
    siteJson,
    cookieConsentJson,
  } = data;

  return (
    <Website
      content={{
        ...privacySurveillanceJson,
        menu: siteJson?.content,
        cookieConsent: cookieConsentJson,
        logo: logoJson,
        socialMedia: socialMediaJson,
      }}>
      <Layout>
        <PrivacySurveillance />
      </Layout>
    </Website>
  );
};

export default PrivacySurveillancePage;

export const query = graphql`
  query PrivacySurveillancePageQuery {
    privacySurveillanceJson {
      hero {
        background {
          image {
            xl
            lg
            md
            sm
            xs
          }
        }
        title
        text
      }
      intro {
        title
        greece {
          title
          data {
            id
            label
            details
          }
        }
      }
      statements {
        tabs {
          id
          label
          title
          text
          list {
            items
          }
          extraText
        }
      }
      meta {
        description
        title
      }
    }
    siteJson {
      ...SiteJsonFragment
    }
    cookieConsentJson {
      ...CookieConsentJsonFragment
    }
    logoJson {
      ...LogoJsonFragment
    }
    socialMediaJson {
      ...SocialMediaJsonFragment
    }
  }
`;
